(() => {
  'use strict';
  let pending = false;
  let cartBusy = false;
  const root = () => window.Shopify?.routes?.root || '/';
  document.addEventListener('broek:cart-mutation-start', () => { cartBusy = true; });
  document.addEventListener('broek:cart-mutation-end', () => { cartBusy = false; });
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-bcx-variant]')) return;
    const card = event.target.closest('[data-bcx-card]');
    card.querySelector('[data-bcx-add]').disabled = !event.target.value;
    const price = event.target.selectedOptions[0]?.dataset.price;
    if (price) card.querySelector('[data-bcx-price]').textContent = price;
  });
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-bcx-add]');
    if (!button || button.disabled || pending || cartBusy) return;
    const block = button.closest('[data-broek-cross-sell]');
    const variant = button.closest('[data-bcx-card]').querySelector('[data-bcx-variant]');
    if (!variant.value) { variant.reportValidity(); return; }
    const status = block.querySelector('[data-bcx-status]');
    const full = document.querySelector('#main-cart-items');
    const fullId = full?.dataset.id;
    const sectionIds = ['minicart-form'];
    if (fullId) sectionIds.push(fullId);
    const scroller = document.querySelector('#minicart-form .overflow-y-scroll');
    const scrollTop = scroller?.scrollTop || 0;
    const label = button.textContent;
    pending = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = block.dataset.adding;
    document.dispatchEvent(new CustomEvent('broek:cart-mutation-start'));
    let added = false;
    try {
      const response = await fetch(root() + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(variant.value), quantity: 1 }], sections: sectionIds, sections_url: location.pathname }),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || block.dataset.error);
      added = true;
      const parser = new DOMParser();
      const nextMini = parser.parseFromString(result.sections?.['minicart-form'] || '', 'text/html').querySelector('#minicart-form');
      const currentMini = document.querySelector('#minicart-form');
      if (currentMini) {
        if (!nextMini) throw new Error(block.dataset.error);
        currentMini.innerHTML = nextMini.innerHTML;
      } else if (!fullId) throw new Error(block.dataset.error);
      if (fullId) {
        const nextMain = parser.parseFromString(result.sections?.[fullId] || '', 'text/html').querySelector('#main-cart-items');
        if (!nextMain) throw new Error(block.dataset.error);
        full.replaceWith(nextMain);
      }
      const drawer = document.querySelector('#minicart_wrapper');
      if (typeof drawer?.cartAction === 'function') drawer.cartAction();
      document.querySelector('#minicart-form .overflow-y-scroll')?.scrollTo({ top: scrollTop });
      const newBlock = document.querySelector(fullId && !drawer?.classList.contains('open') ? '#main-cart-items [data-broek-cross-sell]' : '#minicart-form [data-broek-cross-sell]');
      const newStatus = newBlock?.querySelector('[data-bcx-status]');
      if (newStatus) { newStatus.textContent = block.dataset.added; newStatus.tabIndex = -1; newStatus.focus({ preventScroll: true }); }
      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { source: 'broek-cross-sell', item: result } }));
      window.dispatchEvent(new CustomEvent('broek:cart-drawer-refreshed'));
    } catch (error) {
      if (added) { location.assign(root() + 'cart'); return; }
      status.textContent = error.message || block.dataset.error;
    } finally {
      pending = false;
      button.disabled = false;
      button.textContent = label;
      button.removeAttribute('aria-busy');
      document.dispatchEvent(new CustomEvent('broek:cart-mutation-end'));
    }
  });
})();
